angular.module('app.api').factory('ForgetPasswordApi', [
  'api',
  function ForgetPasswordApi(api) {
    var forgetPasswordApi = {
      changePassword: payload => {
        return api.post('auth/change-password', payload)
      },
    }
    return forgetPasswordApi
  },
])



// WEBPACK FOOTER //
// ./scripts/forgot-password/forgot-password.api.js